class ArticleToc extends HTMLElement {
  #sections = [];
  #activeId = null;
  #raf = 0;
  #onScroll = null;

  connectedCallback() {
    const links = Array.from(this.querySelectorAll('.article-toc__link'));
    if (links.length === 0) return;

    this.#sections = links
      .map((link) => {
        const id = link.getAttribute('href')?.slice(1);
        const el = id ? document.getElementById(id) : null;
        return el ? { id, el, link } : null;
      })
      .filter(Boolean);

    if (this.#sections.length === 0) return;

    for (const { link } of this.#sections) {
      link.addEventListener('click', () => {
        requestAnimationFrame(() => link.blur());
      });
    }

    this.#onScroll = () => {
      if (this.#raf) return;
      this.#raf = requestAnimationFrame(() => {
        this.#raf = 0;
        this.#updateActive();
      });
    };

    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onScroll, { passive: true });
    this.#updateActive();
  }

  disconnectedCallback() {
    if (this.#onScroll) {
      window.removeEventListener('scroll', this.#onScroll);
      window.removeEventListener('resize', this.#onScroll);
    }
    if (this.#raf) {
      cancelAnimationFrame(this.#raf);
    }
  }

  #getScrollOffset() {
    const header = document.getElementById('tt-header');
    const headerHeight = header?.offsetHeight ?? 0;
    return Math.max(headerHeight + 24, 100);
  }

  #updateActive() {
    const offset = this.#getScrollOffset();
    let active = this.#sections[0];

    for (const section of this.#sections) {
      if (section.el.getBoundingClientRect().top <= offset) {
        active = section;
        continue;
      }
      break;
    }

    if (active.id === this.#activeId) return;
    this.#activeId = active.id;
    this.#setActive(active);
  }

  #setActive({ id, link }) {
    for (const section of this.#sections) {
      const isActive = section.id === id;
      section.link.classList.toggle('article-toc__link--active', isActive);
      if (isActive) {
        section.link.setAttribute('aria-current', 'location');
        continue;
      }
      section.link.removeAttribute('aria-current');
    }
  }
}

customElements.define('article-toc', ArticleToc);
